<template>
	<db-col :width="width" valign="middle" :align="align" :height="height" :class="['h5font-' + (this.bold ? 'bold' : 'thin'), 'h5-icon-' + this.icon + (this.bold ? '-bold' : ''), 'circle-' + circle]" @click="clickHandler" :style="style"><slot></slot></db-col>
</template>

<script>
	export default {
		name: 'icon_',
		
		props: {
			icon: {
				type: String,
				default: ''
			},
			
			width: {
				type: [String, Number],
				default: 48
			},
			
			height: {
				type: [String, Number],
				default: 48
			},
			
			circle: {
				type: Boolean,
				default: false
			},
			
			size: {
				type: [String, Number],
				default: ''
			},
			
			align: {
				type: String,
				default: 'center'
			},
			
			color: {
				type: String,
				default: ''
			},
			
			bold: {
				type: Boolean,
				default: false
			}
		},
		
		data(){
			const obj = {}
			if(this.size){
				Object.assign(obj, {fontSize: parseFloat(this.size / 75) + 'rem'})
			}
			if(this.color){
				Object.assign(obj, {color: this.color})
			}
			return {
				style: obj
			}
		},
		
		methods: {
			clickHandler(){
				this.$emit('click')
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.circle-true{
		animation: circle 1s infinite linear;
	}
</style>
